import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=24d27b62&scoped=true&"
import script from "./Language.vue?vue&type=script&lang=ts&"
export * from "./Language.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Language.vue?vue&type=style&index=1&id=24d27b62&scoped=true&lang=css&"
import style2 from "./Language.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d27b62",
  null
  
)

export default component.exports